const KEY = 'bckt.aid';

function randomId() {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  let value = '';
  for (const byte of bytes) value += byte.toString(16).padStart(2, '0');
  return value;
}

function readStorage(storage: Storage | undefined) {
  try {
    return storage?.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

function writeStorage(storage: Storage | undefined, value: string) {
  try {
    storage?.setItem(KEY, value);
  } catch {
    return;
  }
}

export function bindAnonymousSignal() {
  if (typeof window === 'undefined') return;
  let value = readStorage(window.localStorage) || readStorage(window.sessionStorage) || randomId();
  writeStorage(window.localStorage, value);
  writeStorage(window.sessionStorage, value);
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    if (!headers.has('x-bckt-aid')) headers.set('x-bckt-aid', value);
    return originalFetch(input, { ...init, headers });
  };
  if (!('indexedDB' in window)) return;
  try {
    const open = indexedDB.open('bckt', 1);
    open.onupgradeneeded = () => open.result.createObjectStore('kv');
    open.onsuccess = () => {
      const db = open.result;
      const tx = db.transaction('kv', 'readwrite');
      const store = tx.objectStore('kv');
      const get = store.get(KEY);
      get.onsuccess = () => {
        const stored = typeof get.result === 'string' && get.result.length >= 16 ? get.result : value;
        value = stored;
        store.put(stored, KEY);
        writeStorage(window.localStorage, stored);
        writeStorage(window.sessionStorage, stored);
      };
      tx.oncomplete = () => db.close();
    };
  } catch {
    return;
  }
}
